import { render } from "./install-app.vue?vue&type=template&id=62ce6a79"
import script from "./install-app.vue?vue&type=script&lang=js"
export * from "./install-app.vue?vue&type=script&lang=js"

import exportComponent from "/opt/build/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__